/**
 * @desc 样品确认-分页查询
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<
  defs.basics.IPage<defs.basics.ProductConfirmResponseDto>
>;
export function request(
  params: API.basics.productConfirm.pageList.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/productConfirm/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
